<template>
  <div class="chat-head-wrap">
    <input id="contentfilter" type="text" v-model="searchText" placeholder="Search..." />
    <!-- <el-input
      id="contentfilter"
      type="text"
      v-model="searchText"
      placeholder="Search..."
      @keyup.enter.native="search"
    ></el-input>-->
    <a class="submitSearch">
      <img src="../../../static/img/search-icon.png" @click="search" alt />
    </a>
    <div class="popup searchResult" v-if="showSearch">
      <div class="popupContainer">
        <div class="p-head">
          搜尋結果
          <a class="close" @click="handleclose">
            <img src="../../../static/img/close.png" alt />
          </a>
        </div>
        <div class="p-body">
          <div class="searchMore">
            <div class="searchMorewrp">
              <input class="searchFriend" v-model="searchText" type="text" placeholder="搜尋對話紀錄" />
              <a class="submitSearch">
                <img src="../../../static/img/search-icon.png" @click="search" alt />
              </a>
            </div>
          </div>

          <div class="searchHistory chat-history line-chat foo6">
            <ul>
              <li v-for="(data,index) in message">
                <div>
                  <div class="message-data align-left">
                    <div class="chat-avatar">
                      <img
                        :src="data.UserPicture"
                        onerror="onerror=null;src='../static/img/avatar-default.jpg'"
                      />
                    </div>
                    <span class="message-username">{{ data.UserName }}</span>
                    <span class="message-data-time">{{ data.msgTime }}</span>
                    <ChatMessageText v-if="data.msgType === 'text'" :data="data" />
                  </div>
                  <a class="checkHistory" @click="handleDetail(data)">查看上下文</a>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="popup searchDetail" v-if="showDetail">
      <div class="popupContainer">
        <div class="p-head">
          搜尋結果
          <a class="close" @click="handlecloseDetail">
            <img src="../../../static/img/close.png" alt />
          </a>
        </div>
        <div class="p-body">
          <div
            id="chat-history"
            class="chat-history line-chat foo7"
            v-chat-scroll
            @scroll-top="loadTop()"
            @scroll-end="loadMore()"
          >
            <ul>
              <ChatMessage v-for="(message, index) in MessageDetail" :index="index" :key="index" :data="message"></ChatMessage>
            </ul>
          </div>
        </div>
        <div class="p-foot">
          <a class="back" @click="handlecloseDetail">
            <img src="../../../static/img/goBack.png" />返回
          </a>
          <!-- <a class="goPrev" @click="loadMore('top')">
            <img src="../../../static/img/goPrev.png" alt />
          </a>
          <a class="goNext" @click="loadMore('bottom')">
            <img src="../../../static/img/goNext.png" alt />
          </a>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Global from "@/components/Global";
import { ChatContainerHandler } from "@/handler/ChatContainerHandler.js";
import ChatMessageText from "../../components/Main/ChatMessageText";
import ChatMessage from "../Main/ChatMessage.vue";
import { Loading } from "element-ui";

function scrollBottom() {
  if (this.lazyload_top === true) {
    this.lazyload_top = false;
    $("#chat-history").animate(
      {
        scrollTop: $("#comment").offset().top
      },
      10
    );
  }
}

export default {
  components: {
    ChatMessageText,
    ChatMessage
  },
  computed: {
    MessageDetail: function() {
      this.$nextTick(scrollBottom);
      return this.messageDetail;
    }
  },
  data() {
    return {
      message: [],
      searchText: "",
      showSearch: false,
      showDetail: false,
      messageDetail: [],
      lazyload_top: false
    };
  },
  methods: {
    loadTop: function(data) {
      let loadingInstance = Loading.service({ fullscreen: true });

      var hid = this.messageDetail[0].Hid;
      var sort = "ASC";

      var messages_ = ChatContainerHandler.GetMessagesByMessageId(
        Global.current_roomid,
        hid,
        sort,
        Global.current_staffid
      );

      for (var i = 0; i < messages_.length; i++) {
        var obj = this.messageDetail.filter(function(elem) {
          if (elem.Hid == messages_[i].Hid) return elem;
        });

        if (obj.length > 0) {
          continue;
        }
        this.messageDetail.unshift({
          Hid: messages_[i].Hid,
          frmId: messages_[i].frmId,
          UserName: messages_[i].UserName,
          Text: messages_[i].Text,
          msgTime: this.convertUTCDateToLocalDate(messages_[i].msgTime),
          msgType: messages_[i].msgType,
          filePath: messages_[i].filePath,
          previewImageUrl: messages_[i].previewImageUrl,
          senderType: messages_[i].senderType,
          UserPicture: messages_[i].UserPicture
        });
      }
      this.lazyload_top = true;
      loadingInstance.close();
    },
    loadMore: function() {      
      let loadingInstance = Loading.service({ fullscreen: true });
      var hid = this.messageDetail[this.messageDetail.length - 1].Hid;
      var sort = "DESC";
      var messages_ = ChatContainerHandler.GetMessagesByMessageId(
        Global.current_roomid,
        hid,
        sort,
        Global.current_staffid
      );
      for (var i = 0; i < messages_.length; i++) {
        var obj = this.messageDetail.filter(function(elem) {
          if (elem.Hid == messages_[i].Hid) return elem;
        });

        if (obj.length > 0) {
          continue;
        }

        this.messageDetail.push({
          Hid: messages_[i].Hid,
          frmId: messages_[i].frmId,
          UserName: messages_[i].UserName,
          Text: messages_[i].Text,
          msgTime: this.convertUTCDateToLocalDate(messages_[i].msgTime),
          msgType: messages_[i].msgType,
          filePath: messages_[i].filePath,
          previewImageUrl: messages_[i].previewImageUrl,
          senderType: messages_[i].senderType,
          UserPicture: messages_[i].UserPicture
        });
      }

      loadingInstance.close();
    },
    handleDetail(data) {
      let loadingInstance = Loading.service({ fullscreen: true });
      var message_ = ChatContainerHandler.GetMessagesByMessageId(
        Global.current_roomid,
        data.Hid,
        "DESC",
        Global.current_staffid
      );

      for (var i = 0; i < message_.length; i++) {
        message_[i].msgTime = this.convertUTCDateToLocalDate(
          message_[i].msgTime
        );
      }

      this.messageDetail = message_;

      loadingInstance.close();
      this.showDetail = true;
    },
    search(event) {
      if (this.searchText == "") {
        return false;
      }

      if ($("#contentfilter").val() != this.searchText) {
        return false;
      }

      this.showSearch = true;
      let loadingInstance = Loading.service({ fullscreen: true });

      var message_ = ChatContainerHandler.SearchKeyWord(
        Global.current_roomid,
        Global.current_staffid,
        this.searchText
      );

      for (var i = 0; i < message_.length; i++) {
        message_[i].msgTime = this.convertUTCDateToLocalDate(
          message_[i].msgTime
        );
      }
      this.message = message_;
      loadingInstance.close();
    },
    handleclose() {
      this.showSearch = false;
      this.searchText = "";
      this.message = [];
    },
    handlecloseDetail() {
      this.showDetail = false;
    }
  }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Main/ChatSearch.vue